import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../environments/environment';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class LanguageHelper implements ILanguageHelper {

    private readonly LANGUAGEVALUE: string = 'EVETCO_LANGUAGE_SELECTION';

    constructor(public router: Router, private translate: TranslateService) {
        translate.setDefaultLang('fi');
    }

    setLanguage(language): void {
        this.translate.use(language);
        localStorage.setItem(this.LANGUAGEVALUE, language);
    }

    getLanguages(): any[] {
        return environment.languages;
    }

    getCurrentLang(): string {
        const value: string = localStorage.getItem(this.LANGUAGEVALUE);
        console.log(value);
        if (value == null) {
            return 'fi';
        } else {
            return value;
        }
    }
}

export interface ILanguageHelper {
    setLanguage(url: string): void;

    getLanguages(): any[];

    getCurrentLang(): string;
}
